<template>
  <v-text-field
    v-bind="{
      ...$attrs,
      ...commonAttrs
    }"
    v-on="$listeners"
    ref="textField"
  >
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="data">
      <slot :name="scopedSlotName" v-bind="data"/>
    </template>

    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName"/>
    </template>
  </v-text-field>
</template>

<script>
import {autocompleteOff} from "@/mixins/autocomplete-off/autocomplete-off"

/**
 * Текстовое поле, обертка над v-text-field из библиотеки Vuetify.
 * По умолчанию во все компоненты передается значение autocomplete="new-password" для отключения автозаполнения.
 */
export default {
  name: 'x-text-field',
  mixins: [autocompleteOff],
  computed: {
    commonAttrs() {
      return {
        autocomplete: this.attrAutocomplete,
        hideDetails: this.$attrs.hideDetails ?? 'auto',
        outlined: this.$attrs.outlined ?? true,
        clearable: this.$attrs.clearable ?? true
      }
    }
  }
}
</script>

<style scoped>

</style>